import React from 'react';
import cx from 'classnames';

import styles from './UpdateArrow.module.scss';
import usePresenter from './UpdateArrow.presenter';
import getProps from './UpdateArrow.props';
import { UpdateArrowCombinedProps } from './types';

const UpdateArrow: React.FC<UpdateArrowCombinedProps> = (props) => {
  const {
    className,
    classes,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.updateArrow;

  return (
    <div className={cx(currentStyle, className)} />
  );
};

export default UpdateArrow;
